import Big from 'big.js'
import { useEffect, useRef, useState } from 'react'

import { DRAWER_ANIMATION_DURATION } from '../hooks/useOperationDrawer'
import { usePrevious } from '../hooks/usePrevious'
import { uiCryptoDecimals } from '../utils'

const OperationUnitInput = function ({
  autoFocus,
  className,
  disableInputs,
  focusOnTokenChange = true,
  initialValue,
  inputProps,
  onChange,
  onFocus,
  selectedToken,
  setValue,
  value
}) {
  const previousInitialValue = usePrevious(initialValue)
  const inputRef = useRef(null)
  const [displayValue, setDisplayValue] = useState('')
  const validationRegex = /^\d*\.?\d*$/
  const previousValue = usePrevious(value)

  useEffect(
    function () {
      if (initialValue !== previousInitialValue) {
        setValue(initialValue)
      }
    },
    [initialValue, previousInitialValue, setValue]
  )

  useEffect(
    function () {
      if (focusOnTokenChange || autoFocus) {
        setTimeout(function () {
          inputRef.current && inputRef.current.focus()
        }, DRAWER_ANIMATION_DURATION)
      }
    },
    [autoFocus, focusOnTokenChange, selectedToken]
  )

  useEffect(
    function () {
      if (selectedToken && previousValue !== value) {
        if (value) {
          onChange?.(value)
        } else {
          onChange?.(0)
        }
      }
    },
    [onChange, previousValue, selectedToken, value]
  )

  useEffect(
    function () {
      if (value) {
        setValue?.(value)
      }
    },
    [setValue, value]
  )

  useEffect(
    function () {
      if (value === 0 || value === '0') {
        setDisplayValue('')
      } else {
        // If the user is directly typing, the value would be a string, and we don't want to change it as they are typing
        // If the value is a Big instance, we assume it's being set from outside, and we want to round it's decimals
        // @TODO: this is not intuitive, we might need to refactor, but for now keep than in mind
        setDisplayValue(
          value instanceof Big
            ? value.toFixed(uiCryptoDecimals, Big.roundDown)
            : value
        )
      }
    },
    [value]
  )

  const handleInputChange = function (newValue) {
    if (!validationRegex.test(newValue)) {
      return
    }
    setDisplayValue(newValue)
    setValue(newValue.startsWith('.') ? `0${newValue}` : newValue)
  }

  const handleFocus = function (e) {
    e.target.placeholder = ''
    onFocus?.()
  }

  return (
    <div className="text-gray-4 text-sm leading-6">
      <span className="text-heading3 block leading-[34px]">
        <input
          className={`${
            className
              ? className
              : 'w-full bg-transparent placeholder-gray-500 focus:outline-none'
          } ${disableInputs ? 'cursor-not-allowed' : ''}`}
          data-sentry="operation-input"
          disabled={disableInputs}
          onBlur={e => (e.target.placeholder = '0')}
          onChange={e => handleInputChange(e.target.value || '0')}
          onFocus={handleFocus}
          placeholder="0"
          ref={inputRef}
          value={displayValue}
          {...inputProps}
        />
      </span>
    </div>
  )
}

export default OperationUnitInput
